"use strict";

const vuestore = new Vuex.Store({
  modules: {
    base: vueBaseStore,
    cart: vuestoreCart,
    cabs: vuestoreCabs,
  },
});

/**
 * CartProductApi - Batch product fetching via GraphQL Storefront API
 * Replaces N individual REST calls with a single GraphQL request
 */
var CartProductApi = {
  cache: new Map(),

  query: `query getCartProducts($ids: [ID!]!) {
    nodes(ids: $ids) {
      ... on Product {
        id
        handle
        title
        tags
        productType
        images(first: 50) {
          nodes { url }
        }
        variants(first: 100) {
          nodes {
            id
            sku
            title
            price { amount }
            compareAtPrice { amount }
            availableForSale
          }
        }
      }
    }
  }`,

  /**
   * Transform GraphQL product to REST-compatible format
   * Matches the structure returned by /products/{handle}.json
   */
  transformProduct: function(gql) {
    if (!gql) return null;
    return {
      id: parseInt(OAStorefrontApi.toNumericId(gql.id)),
      handle: gql.handle,
      title: gql.title,
      tags: gql.tags, // array, as /products/{handle}.js gives it, so indexOf is an exact tag match
      product_type: gql.productType,
      variants: gql.variants.nodes.map(function(v) {
        return {
          id: parseInt(OAStorefrontApi.toNumericId(v.id)),
          sku: v.sku,
          title: v.title,
          price: Math.round(parseFloat(v.price.amount) * 100).toString(),
          compare_at_price: v.compareAtPrice ? Math.round(parseFloat(v.compareAtPrice.amount) * 100).toString() : null,
          inventory_quantity: v.availableForSale ? 1 : 0,
          available: v.availableForSale
        };
      }),
      image: gql.images.nodes[0] ? { src: gql.images.nodes[0].url } : null,
      images: gql.images.nodes.map(function(img) { return { src: img.url }; })
    };
  },

  /**
   * Fetch products by IDs using batch GraphQL
   * @param {Array<number|string>} productIds - Product IDs to fetch
   * @returns {Promise<Array<Object|null>>} Products in same order as input IDs
   */
  fetchProducts: function(productIds) {
    var self = this;
    var uncached = productIds.filter(function(id) { return !self.cache.has(String(id)); });

    if (uncached.length === 0) {
      return Promise.resolve(productIds.map(function(id) { return self.cache.get(String(id)); }));
    }

    return OAStorefrontApi.fetch(this.query, { ids: OAStorefrontApi.toGids('Product', uncached) })
      .then(function(data) {
        if (!data || !data.nodes) return null;
        data.nodes.forEach(function(node) {
          if (node) {
            var id = OAStorefrontApi.toNumericId(node.id);
            self.cache.set(id, self.transformProduct(node));
          }
        });
        return productIds.map(function(id) { return self.cache.get(String(id)); });
      });
  }
};

var VueCart = Vue.extend({
  delimiters: vueDelimiters,
  props: ['currentShop', 'currentLang', 'hasCustomer', 'customerTags', 'settingSaleAjax', 'settingFashionpromo','settingFashionpromoValue', 'flatrateVariantids', 'flatrateProdids', 'flatratePrice', 'flatrateCompprice'],
  data: function () {
    return {
      cartItems: [/* { product_data: {}, index: null }*/],
      loadcartItems: [],
      disableBtn: false,
      isBusy: false, 
      cartType: null,
      giftscale: {
        settings: [],
        products: {},
      },
      cartData: {
        currencyCode: this.$store.getters['base/currencyCode'],
        priceSeparatorUs: this.$store.getters['base/priceSeparatorUs'],
        total_price: 0,
        original_total_price: 0,
        regularprice: 0,
        subtotal: 0,
        yousafe: 0,
        discount: "",
        discountLoading: false,
        removedDiscount: null,
        currentDiscount: null,
        discountData: null,
        discountValue: 0,
        discountPerc: 0,
        discountType: null,
        SuccessMessageCheck: false,
        SuccessMessage: null,
        dangerMessageCheck: false,
        dangerMessage: "",
        cartCount: 0,
        cartWeight: 0,
        cartShippingRate: 0,
        freeProductCount: 0,
        removedItem: [],
        removedItemId: null,
        removedItemTitle: null,
        removedItemSuccess: false,
        removedItemWishlistSuccess: false,
        removedItemQuantity: null,
        removedItemPrice: null,

        cartWishlistIds: [],
        cartWishlist: {},
        cartRewards: {},
        cartRewardsSelected: {
          selected: null,
          items: [],
          radioIndex: null,
          prevItem: null,
          disableReward: false,
          forceRemove: false,
        },
      },
      cartError: null,
      cartErrorDuration: 5000,
      adCookie: false,
      weekendDelay: false,
      offerShop: false,
      noteTracking: null,
      shippingFlatrate: {
        currentVersion: false,
        version: [
          // {
          //   prodId: parseInt(this.flatrateProdids.split('|')[0]),
          //   variantId: parseInt(this.flatrateVariantids.split('|')[0]),
          //   price: parseInt(this.flatratePrice.split('|')[0]),
          //   compprice: parseInt(this.flatrateCompprice.split('|')[0])
          // },
          // {
          //   prodId: parseInt(this.flatrateProdids.split('|')[1]),
          //   variantId: parseInt(this.flatrateVariantids.split('|')[1]),
          //   price: parseInt(this.flatratePrice.split('|')[1]),
          //   compprice: parseInt(this.flatrateCompprice.split('|')[1])
          // },
          // {
          //   prodId: parseInt(this.flatrateProdids.split('|')[2]),
          //   variantId: parseInt(this.flatrateVariantids.split('|')[2]),
          //   price: parseInt(this.flatratePrice.split('|')[2]),
          //   compprice: parseInt(this.flatrateCompprice.split('|')[2])
          // }
        ]
      },

      maxCartItemQuantity: 50,

      productVarId: "",
      fashionPromo: {
        promoProducts: {
          leggings: [],
          tops: []
        },
        leggingSelected: {
          selected: -1,
          selectedSize: -1
        },
        topSelected: {
          selected: -1,
          selectedSize: -1
        }
      },
      tracking: {
        changedItem: []
      }
    };
  },

  mounted: function mounted() {
    this.cartItems = [];
    this.loadCart().finally(function () {
      setTimeout(function () {
        $('.se-pre-con').fadeOut(225);
      }, 200);
    });
    this.setupFreeGifts();
  
  },

  methods: {
    ASFreeGift: function ASFreeGift(threshold, variant, product, message, category) {
      return { over: threshold, variant_id: variant, product_id: product, category: category || null, message: message };
    },
    ASFreeSportswearGift: function ASFreeSportswearGift(threshold, variant, product, message) {
      return this.ASFreeGift(threshold, variant, product, message, 'sportswear');
    },
    setupFreeGifts: function setupFreeGifts(){
      var currentShop = this.$store.state.base.currentShop;


      if (this.$store.state.base.customerTags && this.$store.state.base.customerTags.indexOf('oa_tier_gold') !== -1 && false) {
        var threshold1;
        switch (currentShop) {
          case 'com':
            threshold1 = 7000;
            this.giftscale.settings = [
              this.ASFreeSportswearGift(threshold1, 56445830168963, 15379489325443, 'T-Shirt OA')
            ];
            break;
          case 'us':
            threshold1 = 27000;
            this.giftscale.settings = [
              this.ASFreeSportswearGift(threshold1, 49662228988247, 9768989131095, 'Classic Tote')
            ];
            break;
          case 'ca':
            threshold1 = 27000;
            this.giftscale.settings = [
              this.ASFreeSportswearGift(threshold1, 54866877284738, 14877220667778, 'Classic Tote')
            ];
            break;
          case 'au':
            threshold1 = 27000;
            this.giftscale.settings = [
              this.ASFreeSportswearGift(threshold1, 49542013059408, 9675917132112, 'Classic Tote')
            ];
            break;
          case 'uk':
            threshold1 = 21000;
            this.giftscale.settings = [
              this.ASFreeSportswearGift(threshold1, 54866877055362, 14877220471170, 'Classic Tote')
            ];
            break;
          case 'eu':
            threshold1 = 25000;
            this.giftscale.settings = [
              this.ASFreeSportswearGift(threshold1, 54866877088130, 14877220438402, 'Classic Tote')
            ];
            break;
          case 'de':
            threshold1 = 25000;
            this.giftscale.settings = [
              this.ASFreeSportswearGift(threshold1, 49662228889943, 9768989065559, 'Classic Tote')
            ];
            break;
        }
      }

    },
    // compare price formatter
    compareformat: function (value, index, qty) {
      return this.moneyformat(value.replace('.', '') * qty);
    },
    // compare price formatter for free section
    compareformatfree: function (value, index, qty) {
      var comparePrice = ((value / 100) * qty)
          .toFixed(2)
          .toString()
          .replace(".", ",");

      return this.$store.getters['base/currencySymbol'] + " " + comparePrice;
    },
    // price formatter for Tracking
    moneyformatTracking: function (value) {
      return (value / 100).toFixed(2).toString();
    },

    validateRewardProduct: function validateRewardProduct(item) {
      if(item.properties != null && item.properties.reward && item.properties.reward === true){
        var rewardItem = item;
        var rewardIndex = 0;
        if(this.cartData.cartRewards.rewards){
          this.cartData.cartRewards.rewards.forEach(function(item,index){
            if(rewardItem.product_id == item.id){
              rewardIndex = index;

            }
          });

          if(this.cartData.cartRewardsSelected.forceRemove !== true){
            if(this.cartData.cartRewardsSelected.radioIndex == null){
              this.cartData.cartRewardsSelected.radioIndex = rewardIndex;

              this.cartData.cartRewardsSelected.prevItem = rewardItem.id;
              //console.log(rewardItem.variant_options[0], rewardItem.id);
            }
          }

        }
        return true;
      }else{
        return false;
      }
    },

    weekendDelayCalc: function weekendDelayCalc() {

      var d = new Date(),
          localTime = d.getTime(),
          localOffset = d.getTimezoneOffset() * 60000,
          utc = localTime + localOffset,
          utcDate = new Date(utc);

      //console.log(utcDate.getHours())


      if(utcDate.getDay() == 6 || utcDate.getDay() == 0 || (utcDate.getDay() == 5 && utcDate.getHours() > 15)){
        this.weekendDelay = true;
      }

      //this.weekendDelay = true;
    },
    setUpDragSlide: function setUpDragSlide() {
      let mouseDown = false;
      let startX, scrollLeft;
      const sliders = document.querySelectorAll('.oa-cart--scrollbar');

      if(sliders.length == 0){
        return;
      }

      sliders.forEach(function(slider){
        if(slider.classList.contains('slide--applied')){return;}
        const startDragging = (e) => {
          mouseDown = true;
          startX = e.pageX - slider.offsetLeft;
          scrollLeft = slider.scrollLeft;
        }

        const stopDragging = (e) => {
          mouseDown = false;
        }

        const move = (e) => {
          e.preventDefault();
          if(!mouseDown) { return; }
          const x = e.pageX - slider.offsetLeft;
          const scroll = x - startX;
          slider.scrollLeft = scrollLeft - scroll;
        }
        slider.addEventListener('mousemove', move, false);
        slider.addEventListener('mousedown', startDragging, false);
        slider.addEventListener('mouseup', stopDragging, false);
        slider.addEventListener('mouseleave', stopDragging, false);
        slider.classList.add('slide--applied');

      });
    },
    checkOfferShop: function checkOfferShop(){
      if(window.Cookies.get('special-offer')!==undefined){
        this.offerShop = true;

      }
    },
    checkCookieForAd: function checkCookieForAd(){
      var adDiscountName = 'IDJW4Q';
      var cookiediscount = Cookies.get('ad-script', {domain: '.oneractive.com'});
      //console.log('cookie discount' , cookiediscount)
      if(cookiediscount == adDiscountName){
        this.adCookie = true;
        this.cartData.discount = adDiscountName;
      }
    },

    showHideFixedCheckout: function showHideFixedCheckout() {
      if (!this.$refs.priceListingTotal || !this.$refs.fixedPriceListingTotal || !this.$refs.checkoutFixed) {
        return;
      }
      return;
      var ot = (this.$refs.priceListingTotal.getBoundingClientRect().bottom || 0) + (window.scrollY || document.documentElement.scrollTop) - (document.documentElement.clientTop  || 0);
      var otF = (this.$refs.fixedPriceListingTotal.getBoundingClientRect().top || 0) + (window.scrollY || document.documentElement.scrollTop) - (document.documentElement.clientTop  || 0);
      var x = window.screen.height + window.scrollY;
      if (ot - x < 0) {
        this.$data.hasSeenPriceListingTotal = true;
      }
      if (this.$data.hasSeenPriceListingTotal !== true) {
        //return;
      }
      var hide = parseInt(otF) - parseInt(ot) > 0;
      if (document.getElementById('smile-ui-container') !== null) {
        var smileFContainer = document.getElementById('smile-ui-container').querySelector('.smile-launcher-frame-container');
        if(smileFContainer !== null){
          smileFContainer.style.marginBottom = hide ? 0 : this.$refs.checkoutFixed.offsetHeight + 'px';
        }
      }
      this.$refs.checkoutFixed.style.transform = hide ? '' : 'none';
      this.$refs.checkoutFixed.style.height = hide ? '' : 'auto';
    },

    //load cart information
    loadCart: function loadCart() {
      var self = this;
      this.isBusy = true;
      this.disableBtn = true;

      return Promise.all([
        this.$store.dispatch('cart/fetch'),

        axios({
          url: "/cart.json",
          method: "get",
          headers: { 'Cache-Control': 'no-cache, no-store', 'Pragma': 'no-cache', 'Expires': 0 }
        })
            .then((response)=> {
              self.cartData.total_price = response.data.total_price;
              self.cartData.original_total_price = response.data.original_total_price;

              self.loadcartItems = response.data.items.map(function(item) {
                item.product_data = {};
                item.product_data_status = false;
                return item;
              });

              // Batch fetch all products via GraphQL (single request instead of N REST calls)
              var productIds = self.loadcartItems
                .map(function(item) { return item.product_id; })
                .filter(function(id, i, arr) { return arr.indexOf(id) === i; }); // unique

              return CartProductApi.fetchProducts(productIds)
                  .then(function(products) {
                    var productMap = {};
                    if (products) {
                      products.forEach(function(p) { if (p) productMap[p.id] = p; });
                    }
                    self.loadcartItems.forEach(function(item) {
                      var product = productMap[item.product_id];
                      if (product) {
                        item.product_data = product;
                        item.product_data_status = true;
                      }
                    });

                    // Handle unpublished products
                    self.loadcartItems = self.loadcartItems.filter(function (item) {
                      return item.product_data_status;
                    });
                    //console.log("self.loadcartItems",self.loadcartItems)
                    self.checkloadedcartItems();
                    self.subtotalCal();

                    if (self.loadcartItems.length < 1) {
                      self.cartData.cartCount = 0;
                      self.cartItems = self.loadcartItems;
                    }
                    //console.log("self.cartData",self.cartData)
                    //console.log("self.cartItems",self.cartItems)

                    dispatchEvent(new CustomEvent("cart:updated", {
                      detail: { items: self.cartItems, total: self.cartData.total_price }
                    }));
                  });
            })
            /*
            .then(function (d) {
              if (typeof Nosto !== 'undefined') {
                //disabled to prevent double load
                Nosto.reloadCart();
              }
              return d;
            })
            */
            .catch(function(error) {
              console.log(error);
            })
      ]);
    },

    scrollToTop: function scrollToTop() {
      window.scrollTo(0,0);
    },

    setCartError: function setCartError(error) {
      var data = error && error.response && error.response.data;
      var status = error && error.response && error.response.status;
      var msg = (data && (data.errors || data.description || data.message)) || null;
      if (!msg) return;
      this.cartErrorDuration = (status === 422) ? 30000 : 5000;
      this.cartError = msg;
      this.scrollToTop();
    },

    clearCart: function clearCart() {
      history.replaceState(null, '', window.location.pathname + window.location.search);
      // /cart/clear.json may be blocked by the checkout block app,
      // so delete the cart cookie directly and reload for a fresh empty cart
      document.cookie = 'cart=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      window.location.reload();
    },
    // change quantity of cartitem
    itemChange: function itemChange(item, index, value) {
      var self = this;
      var forceReduction = false;
      if(item.sku == "9010128000807" || item.sku == "9010128008162"){
        var saleItemQty = 0;
        self.cartItems.forEach(function(itemc, index) {
          if(itemc.sku == "9010128000807" || itemc.sku == "9010128008162"){
            saleItemQty = saleItemQty + itemc.quantity;
          }
        });
        if(saleItemQty % 2 === 0 ){
          if(value < 0){
            value = -2;
          }else if (value > 0){
            value = 2;
          }
        }else{}
        //console.log(value);
        if(item.quantity + value == 0){
          //console.log('remove item if not disabled');
          var forceReduction = true;
        }
      }

      if (self.disableBtn == true) {
        return;
      } else {
        if (item.quantity + value < 1 && forceReduction == false) {
          return;
        } else if (item.quantity + value > this.maxCartItemQuantity) {
          alert("not more than " + this.maxCartItemQuantity + " pieces");
          item.quantity = this.maxCartItemQuantity - 1;
        }
        var itemId = item.id;
        var itemQty = item.quantity + value;

        var quantity = this.cartItems[index].quantity + value;

        // BOGO product: +2 or -2 if total quantity is even, else just +1 or -1 to fix the quantity.
        //if (item.properties && item.properties.returnable === '0' && this.cartItems.filter(function(i) { return i.handle === item.handle; }).reduce(function (sum, i) { return sum + i.quantity; }, 0) % 2 === 0) {
        //  quantity = this.cartItems[index].quantity + (value * 2);
        //}

        axios({
          url: "/cart/change.json",
          method: "post",
          data: {
            quantity: quantity,
            line: index + 1
          }
        })
            .then(function(response) {
              document.dispatchEvent(new CustomEvent('oa:checkloadedcartItems'));
              self.loadCart();
              document.dispatchEvent(new CustomEvent('oa:changecarttracking', { detail: { sku: item.sku, qty: value } }));
              self.subtotalCal();
            })
            .catch(function(error) {
              self.setCartError(error);
              console.log(error);
            });
      }
    },
    // change cartData by jsonData
    changeCart: function changeCart(postData) {
      var self = this;
      axios({
        url: "/cart/change.json",
        method: "post",
        data: postData
      })
          .then(function(response) {
            self.loadCart();
            self.subtotalCal();
          })
          .catch(function(error) {
            return console.log(error);
          });
    },

    // remove item from cart
    removeItem: function removeItem(item, index, options = {}) {
      var self = this;
      axios({
        url: "/cart/change.json",
        method: "post",
        data: {
          quantity: 0,
          line: item.index + 1
        }
      })
          .then(function(response) {

            if(item.properties.giftpromo == undefined){
              self.cartData.removedItem = item;
              self.cartData.removedItemQuantity = item.quantity;
              self.cartData.removedItemPrice = item.price;
              self.cartData.removedItemTitle = (item.title ?? '').replace(' | ', ' - ').replace(/&quot;/g, '"');
              if (options?.savedToWishlist === true) {
                self.cartData.removedItemWishlistSuccess = true;
              } else {
                self.cartData.removedItemSuccess = true;
              }
            }


            self.loadCart();
            self.subtotalCal();
            document.dispatchEvent(new CustomEvent('oa:checkloadedcartItems'));
            document.dispatchEvent(new CustomEvent('oa:removecarttracking', { detail: { sku: item.sku, qty: '-'+item.quantity } }));
          })
          .catch(function(error) {
            return console.log(error);
          });

      this.eeRemoveCart(item, index, "removeFromCart");
    },

    // add item after deleteing it from cart
    readdItem: function readdItem() {
      var self = this;
      var item = this.cartData.removedItem;
      axios({
        url: "/cart/add.json",
        method: "post",
        data: item
      }).then(function(response) {
        //console.log('itemreadded');
        self.cartData.removedItemSuccess = false;
        self.cartData.removedItemWishlistSuccess = false;
        self.loadCart();
        self.cartChangedSelect();
        self.genericEvent(
            "genericEvent",
            "Cart",
            "Undo",
            self.cartData.removedItemTitle
        );
      });
    },

    //Subtotal & Cart Count Calculation
    subtotalCal: function subtotalCal() {
      var cartCount = 0;
      var sum = 0;
      var sumreg = 0;
      var totalWeight = 0;

      if (this.standartProducts.length > 0) {
        for (var i = 0; i < this.standartProducts.length; i++) {
          var lineWeight =
              this.standartProducts[i].grams * this.standartProducts[i].quantity;

          if (this.standartProducts[i].product_data.variants[this.standartProducts[i].product_data.variants.findIndex(itemvariant => itemvariant.sku == this.standartProducts[i].sku)].compare_at_price > 1 ) {
            var price = this.standartProducts[i].line_price;
            var compareLineTotal =
                this.standartProducts[i].product_data.variants[this.standartProducts[i].product_data.variants.findIndex(itemvariant => itemvariant.sku == this.standartProducts[i].sku)].compare_at_price *
                100 *
                this.standartProducts[i].quantity;
            sumreg += compareLineTotal;
            sum += price;
          } else {
            var price = this.standartProducts[i].line_price;
            sumreg += price;
            sum += price;
          }
          totalWeight += lineWeight;
          var price = this.standartProducts[i].line_price;
          if (price > 0 && this.standartProducts[i].handle != "routeins") {
            cartCount += this.standartProducts[i].quantity;
          }
        }
      }

      this.cartData.cartWeight = totalWeight;
      //this.cartData.total_price = this.cartData.subtotal + this.cartData.cartShippingRate;
      this.cartData.subtotal = sum;
      this.cartData.regularprice = sumreg;
      this.cartData.cartCount = cartCount;
      //vueappCount.cartCount = this.cartData.cartCount;
      /********important header***********/
      window.oaHeader.loadCartCount();
      // window.oaHeader.loadCartCount();
      this.totalCal();
      this.youSafeCal();
      this.smileBPCalc();

      if (this.cartData.subtotal > parseInt(this.settingFashionpromoValue) || this.settingSaleAjax === 'true') {
        document.dispatchEvent(new CustomEvent('oa:checkloadedcartItems'));
      }
    },

    smileBPCalc: function smileBPCalc() {
      if (this.$refs.cartSummarySmilePPValue) {
        var bp_multi = this.$refs.cartSummarySmilePPValue.dataset.bp_multi;
        var totalBestpoints = null;
        this.cartItems.filter(function(item) {if(item.product_data.tags.indexOf('product_line_promotions') == -1){totalBestpoints = totalBestpoints + item.final_line_price}})
        this.$refs.cartSummarySmilePPValue.innerText = Math.round(totalBestpoints * bp_multi / 100);
      }
    },

    //Cart total calculation
    totalCal: function totalCal() {
      var self = this;
      //shipping Total Cal
      if(this.adCookie == true){
        var cartTotal = 0;
        setTimeout(function(){
          //console.log('carttotal adjusted');
          $('[data-ad-price]').each(function(){ cartTotal += parseInt($(this).attr('data-ad-price'))})
          self.cartData.total_price = cartTotal
          // console.log('carttotal adjusted');
        },500);
      }else{

        if (this.cartData.cartWeight > 1500) {
          this.cartData.cartShippingRate = 0;
        } else {
          this.cartData.cartShippingRate = 0;
        }

        if (this.cartData.cartShippingRate > 0) {
          if (
              this.cartData.cartShippingRate > 0 &&
              this.cartData.discountPerc > 0
          ) {
            //console.log('test3');
            this.cartData.total_price =
                this.cartData.subtotal +
                this.cartData.cartShippingRate -
                Math.floor(
                    this.cartData.subtotal * (this.cartData.discountPerc / 100)
                );
          } else if (
              this.cartData.cartShippingRate > 0 &&
              this.cartData.discountPerc == 0
          ) {
            this.cartData.total_price =
                this.cartData.subtotal + this.cartData.cartShippingRate;
            //console.log('test2');
          } else {
            this.cartData.total_price = this.cartData.subtotal;
            //console.log('test1');
          }
        } else {
          if (this.cartData.discountPerc > 0) {
            //console.log('test3');
            this.cartData.total_price =
                this.cartData.subtotal -
                Math.floor(
                    this.cartData.subtotal * (this.cartData.discountPerc / 100)
                );
          } else {
            this.cartData.total_price = this.cartData.subtotal;
            //console.log('test1');
          }
        }

      }
    },

    //you safe cal
    youSafeCal: function youSafeCal() {
      var savings = this.cartData.regularprice - this.cartData.subtotal;
      this.cartData.yousafe = savings;
    },

    // request and save productdata for cartItem
    getProductDataByItem: function getProductDataByItem(item) {
      // recharge product exception
      if(item.properties != null && item.properties.shipping_interval_frequency != undefined){
        var preProductHandle = item.url.match(/([^\/\?]*)(\?.*)?$/)[1].split('-');
        preProductHandle.pop();
        var productHandle = preProductHandle.join('-');
      }else{
        var productHandle = item.url.match(/([^\/\?]*)(\?.*)?$/)[1];
      }
      return axios({
        url: "/products/" + productHandle + ".json",
        method: "get"
      })
          .then(function(response) {
            return response.data.product
          })
          .catch(function(error) {
            console.log(error);
            //window.location.href='/checkout';
            return Promise.resolve();
          });
    },

    // if all productdata of loadcartItems are loaded > set cartItems to loadcartItems
    // (no flicker on screens while cart and products are updated in background
    // with 'loadcartItems' and 'cartItems' are untouched)
    checkloadedcartItems: function checkloadedcartItems() {

      if (
          this.loadcartItems.filter(function(item) {
            return !item.product_data_status;
          }).length === 0
      ) {
        this.cartItems = this.loadcartItems;
        for (var i = 0; i < this.cartItems.length; i++) {
          this.cartItems[i].index = i;
        }

        this.isBusy = false;
        this.disableBtn = false;
        this.cartChangedSelect();

        this.fashionpromoproducts();


        this.checkCartType(true);
        //this.checkFreeGiftsFraud();
        //console.log('check loaded')

      }


    },
    checkCartType: function checkCartType(init){
      var items = this.cartItems;
      items.forEach(function (item) {
        if((item.properties != null && item.properties.reward != undefined) || (item.properties != null && item.properties.giftpromo != undefined)){return;}

        if(vueapp.cartType == null || init){
          vueapp.cartType = "sportswear";
        }
      });
    },
    // change cartitem variant
    // seems not to be possible, so clearing cart and rebuilt cart by 'buildCartByItems'
    changeVariant: function changeVariant(item) {
      this.onChangeTracking(item);
      var self = this;
      this.isBusy = true;
      this.buildcartItems = this.cartItems.filter(function(item) {
        return true;
      });
      axios({
        url: "/cart/clear.json",
        method: "post"
      })
          .then(function(response) {
            self.buildCartByItems();
          })
          .catch(function(error) {
            return console.log(error);
          });
    },

    // rebuild new cart by current cartitems arry
    buildCartByItems: function buildCartByItems() {
      if (this.buildcartItems.length > 0) {
        var item = this.buildcartItems.pop();

        var index = item.index;
        var discountPrice = item.discounted_price;
        var postData = [];

        if (discountPrice < 1) {
          var postData = {
            quantity: item.quantity,
            id: item.variant_id,
            properties: { alreadydiscounted: true }
          };
        } else {
          var postData = {
            quantity: item.quantity,
            id: item.variant_id
          };
        }

        var properties = item.properties;

        if (properties) {
          var postData = {
            quantity: item.quantity,
            id: item.variant_id,
            properties: properties
          };
        }

        var self = this;

        axios({
          url: "/cart/add.json",
          method: "post",
          data: postData
        })
            .then(function(response) {
              self.buildCartByItems();
            })
            .catch(function(error) {
              return console.log(error);
            });
      } else {
        this.loadCart();
      }
    },

    // simple add product ( mainly for adding free products )
    addProduct: function addProduct(variantid, productid) {
      var self = this;

      axios
          .post("/cart/update.json", "updates[" + variantid + "]=1")
          .then(function(response) {
            self.buildCartByItems();
            //console.log("item added");
          })
          .catch(function(error) {
            self.setCartError(error);
          });
    },
    addProductClick: function addProductClick(variantid, productid) {
      var self = this;

      axios
          .post("/cart/add.js", {
            quantity: 1,
            id: variantid
          })
          .then(function(response) {
            self.loadCart();
            //console.log("item added");
            document.dispatchEvent(new CustomEvent('oa:checkloadedcartItems'));
            document.dispatchEvent(new CustomEvent('oa:addtocarttracking', { detail: { sku: response.data.sku, qty: '1', title: response.data.title, prodID: response.data.product_id, variantID: response.data.variant_id } }));
          })
          .catch(function(error) {
            return console.log(error);
          });
    },
    // simple delete product ( mainly for deleting free products )
    deleteProduct: function deleteProduct(variantid, productid) {
      var itemInCart;
      this.cartItems.filter(function(item) {
        if (item.product_id == productid) {
          itemInCart = true;
        } else {
          console.log("item is not in cart");
        }
      });

      if (itemInCart == true) {
        var self = this;

        axios
            .post("/cart/update.json", "updates[" + variantid + "]=0")
            .then(function(response) {
              self.buildCartByItems();
              console.log("item deleted");
            })
            .catch(function(error) {
              self.setCartError(error);
            });
      } else {
        this.loadCart();
      }
    },

    // refresh bootstrap-select selectpicker
    cartChangedSelect: function cartChangedSelect() {
      setTimeout(function() {
        try {
          if (
              /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
          ) {
            $(".cart-item select").selectpicker("mobile");
            $(".oa-cart-rewards-item-container select").selectpicker("mobile");
          }
          $(".cart-item select").selectpicker("refresh");
          $(".oa-cart-rewards-item-container select").selectpicker("refresh");
        } catch (e) {
          //
        }
      }, 1);
    },


    // show/hide discount input
    discountClick: function discountClick() {
      $('.oa-cart-coupon-info').toggleClass('open');
      var checkbox = $('.oa-cart-discount__checkbox');
      checkbox.toggleClass('checked');
      $('.oa-discount-section').slideToggle(200, function () {
        if (checkbox.hasClass('checked')) {
          $('#oa-cart__discount-input').focus();
        }
      });
    },

    // submit discount code to checkout and check if discount is valid
    discountSubmit: function discountSubmit() {
      var discountUrl = "/checkout?discount=" + this.cartData.discount;
      var discountCheckClick = $("#oa-cart__discount-submit");

      if(this.cartData.discount == undefined || this.cartData.discount == ''){
        return;
      }

      this.cartData.discountLoading = true;
      this.cartData.removedDiscount = null;
      //console.log(discountUrl,this.cartData.discount);

      var self = this;

      axios({
        url: discountUrl,
        method: "get"
      })
          .then(function(response) {
            self.cartData.discountLoading = false;
            self.cartData.discountData = response.data;
            var discountValue = $(response.data)
                .contents()
                .find("[data-checkout-discount-amount-target]")
                .attr("data-checkout-discount-amount-target");
            var discountCodeType = $(response.data)
                .contents()
                .find("[data-discount-type]")
                .attr("data-discount-type");
            var errorMessage = $(response.data)
                .contents()
                .find("#error-for-reduction_code")
                .html();
            var warningMessage = $(response.data)
                .contents()
                .find(".notice__text")
                .html();

            self.cartData.discountType = discountCodeType;

            if (errorMessage) {
              self.cartData.SuccessMessageCheck = false;
              console.log("discount error" + errorMessage);
              self.cartData.dangerMessage = errorMessage;
              self.cartData.dangerMessageCheck = true;
              setTimeout(function() {
                self.cartData.dangerMessageCheck = false;
              }, 20000);
              self.genericEvent(
                  "genericEvent",
                  "Error Message",
                  "cart_coupon",
                  self.cartData.dangerMessage
              );
            }else if (warningMessage){
              self.cartData.SuccessMessageCheck = false;
              console.log("discount warning" + warningMessage);
              self.cartData.dangerMessage = warningMessage.replace('<strong>','"').replace('</strong>','"');
              self.cartData.dangerMessageCheck = true;
              setTimeout(function() {
                self.cartData.dangerMessageCheck = false;
              }, 20000);
              self.genericEvent(
                  "genericEvent",
                  "Error Message",
                  "cart_coupon",
                  self.cartData.dangerMessage
              );
            } else {
              if (discountCodeType == "percentage") {
                self.cartData.currentDiscount = self.cartData.discount;
                self.cartData.discountValue = parseInt(discountValue);
                self.cartData.dangerMessageCheck = false;
                self.cartData.discountPerc = Math.round(
                    (self.cartData.discountValue * 100) / self.cartData.subtotal
                );
                self.cartData.SuccessMessageCheck = true;
                if (self.$store.state.base.currentLang == "en") {
                  self.cartData.SuccessMessage =
                      "Discount code is added to your cart.";
                } else {
                  self.cartData.SuccessMessage =
                      "Discount code is added to your cart.";
                }
                setTimeout(function() {
                  self.cartData.SuccessMessageCheck = false;
                }, 20000);
                self.subtotalCal();
              } else if (discountCodeType == "fixed_amount") {
                console.log(discountCodeType);
                self.cartData.currentDiscount = self.cartData.discount;
                self.cartData.SuccessMessageCheck = true;
                if (self.$store.state.base.currentLang == "en") {
                  self.cartData.SuccessMessage =
                      'Your discount code is a "Fixed Amount Discount Code" and will be listed in detail at the Checkout';
                } else {
                  self.cartData.SuccessMessage =
                      'Your discount code is a "Fixed Amount Discount Code" and will be listed in detail at the Checkout';
                }
                setTimeout(function() {
                  self.cartData.SuccessMessageCheck = false;
                }, 20000);
                self.subtotalCal();
              } else if (discountCodeType == "shipping") {
                console.log(discountCodeType);
                self.cartData.currentDiscount = self.cartData.discount;

                self.cartData.SuccessMessageCheck = true;
                if (self.$store.state.base.currentLang == "en") {
                  self.cartData.SuccessMessage =
                      'Your discount code is a "Free Shipping Discount Code" and will be listed in detail at the Checkout';
                } else {
                  self.cartData.SuccessMessage =
                      'Your discount code is a "Free Shipping Discount Code" and will be listed in detail at the Checkout';
                }
                setTimeout(function() {
                  self.cartData.SuccessMessageCheck = false;
                }, 20000);
                self.subtotalCal();
              } else {
                console.log(discountCodeType);
                self.cartData.currentDiscount = self.cartData.discount;
                self.cartData.SuccessMessageCheck = true;
                if (self.$store.state.base.currentLang == "en") {
                  self.cartData.SuccessMessage =
                      "Your discount code will be listed in detail at the Checkout";
                } else {
                  self.cartData.SuccessMessage =
                      "Your discount code will be listed in detail at the Checkout";
                }
                setTimeout(function() {
                  self.cartData.SuccessMessageCheck = false;
                }, 20000);
                self.subtotalCal();
              }
              self.genericEvent(
                  "genericEvent",
                  "Cart",
                  "voucher redeem",
                  self.cartData.currentDiscount
              );
            }
          })
          .catch(function(error) {
            self.cartData.discountLoading = false;
            console.log(error);
          });
    },

    //Check if Discount Code is already added to Checkout
    checkDiscountFromCart: function checkDiscountFromCart() {
      var self = this;
      var discountUrl = "/checkout";
      axios({
        url: discountUrl,
        method: "get"
      }).then(function(response) {
        var codeName = $(response.data).find("[data-discount-type]").find(".reduction-code__text").last().text();

        if (codeName === '') {
          codeName = Cookies.get('discount', {domain: '.oneractive.com'}) || '';
        }

        if (codeName != "") {
          $(".oa-cart-discount__checkbox").addClass("checked");
          $(".oa-discount-section").show(400);

          $("#oa-cart__discount-input").val(codeName);

          self.cartData.discount = codeName;

          //
          var discountUrl = "/checkout?discount=" + self.cartData.discount;
          var discountCheckClick = $("#oa-cart__discount-submit");

          self.cartData.removedDiscount = null;
          //console.log(discountUrl);

          axios({
            url: discountUrl,
            method: "get"
          }).then(function(response) {
            discountCheckClick.html('<i class="fa fa-angle-right"></i>');
            self.cartData.discountData = response.data;
            var discountValue = $(response.data)
                .contents()
                .find("[data-checkout-discount-amount-target]")
                .attr("data-checkout-discount-amount-target");
            var discountCodeType = $(response.data)
                .contents()
                .find("[data-discount-type]")
                .attr("data-discount-type");
            var errorMessage = $(response.data)
                .contents()
                .find("#error-for-reduction_code")
                .html();

            if (discountCodeType == "percentage") {
              self.cartData.currentDiscount = self.cartData.discount;
              self.cartData.discountValue = parseInt(discountValue);
              self.cartData.dangerMessageCheck = false;
              self.cartData.discountPerc = Math.round(
                  (self.cartData.discountValue * 100) / self.cartData.subtotal
              );
              self.subtotalCal();
            } else if (discountCodeType == "fixed_amount") {
              //console.log(discountCodeType);

              self.subtotalCal();
            } else if (discountCodeType == "shipping") {
              //console.log(discountCodeType);

              self.subtotalCal();
            } else {
              //console.log(discountCodeType);

              self.subtotalCal();
            }
          });
        }
      });
    },

    // add cab product to cart
    cabAdd: function cabAdd(product, index, variant) {
      var self = this;
      var ids = [];
      var idCheck = false;
      var itemCount = 0;
      var varid;

      if(variant && !variant.available){
        return;
      }
      if(!product.available){
        return;
      }
      if(window.Cookies.get('special-offer') !== undefined){
        window.OAupdateCartNote('special-offer');
      }
      if (variant) {
        self.$store.commit('cabs/setCartCabSelected', variant);
        itemCount = 1;
      }

      product.variants.forEach(function(item, index) {
        if((typeof item.inventory_quantity === 'undefined' || item.inventory_quantity > 0) && itemCount == 0){
          varid = item.id;
          itemCount = 1;
        }
      });

      var quantity = 1;

      var totalbogo = 0;
      //for buy one get one free

      this.cartItems.filter(function(item) {
        if (item.product_id == 9705691716) {
          totalbogo += 1;
        }
      });

      if (product.id == 8105120769 && totalbogo < 1) {
        quantity = 2;
      }
      //end

      product.variants.filter(function(item, event) {
        if (idCheck == false) {
          if (item.id == self.$store.state.cabs.cartCabSelected.id) {
            idCheck = true;
          } else {
            idCheck = false;
          }
        }
      });

      if (idCheck == true) {
        varid = self.$store.state.cabs.cartCabSelected.id;
      } else {
      }

      axios
          .post("/cart/add.js", {
            quantity: quantity,
            id: varid
          })
          .then(function(response) {
            self.loadCart();

            self.eeAddToCart(product, index);
            document.dispatchEvent(new CustomEvent('oa:checkloadedcartItems'));
            document.dispatchEvent(new CustomEvent('oa:addtocarttracking', { detail: { sku: response.data.sku, qty: '1', title: response.data.title, prodID: response.data.product_id, variantID: response.data.variant_id } }));

          })
          .catch(function(error) {
            return console.log(error);
          });
    },
    // get Wishlist product handles
    wishlistProducts: function wishlistProducts() {

      this.cartData.cartWishlist = {};
      
      let subscription = window.WishlistKing.state.observeWishlist({wishlistId: 'mine'}).subscribe(wishlist => {
        let wishlistItems = new Map(wishlist.items
          .filter(item => item.product?.id)
          .reverse()
          .map((item, index) => [item.product?.id.toString(), index])
        );
        this.cartData.cartWishlistIds = Array.from(wishlistItems.keys());
        if (subscription) {
          subscription.unsubscribe();
        }
        this.getWishlistProduct();
      });
    },
    // get Wishlist products via GraphQL batch fetch
    getWishlistProduct: function getWishlistProduct() {
      var self = this;
      var idsToUse = this.cartData.cartWishlistIds.slice(0, 8);

      if (idsToUse.length === 0) {
        self.cartData.cartWishlist = { products: [] };
        return;
      }

      OAProductsApi.fetchByIds(idsToUse).then(function(products) {
        var filteredProducts = products.filter(function(p) { return p !== null; });
        self.cartData.cartWishlist = { products: filteredProducts };

        setTimeout(function() {
          self.setUpDragSlide();
        }, 200);

        Vue.nextTick(function() {
          if (typeof window.equalHeightInstance !== 'undefined') {
            window.equalHeightInstance.update({ ignoreShopGrid: true, cache: true });
          }
        });
      });
    },

    isItemInStock: function(item) {
      if (!item) { return false; }
      // no check for bundles & giftcards
      if (item.product_type == 'Gift Cards') { return true; }
      if (!item.product_data || !item.product_data.variants) { return true; }
      var variant = item.product_data.variants.filter(function (variant) { return variant.sku === item.sku; })[0];
      // no check if variant not found or inventory quantity not present
      // TODO: inventory_quantity is not present in all shops
      if (!variant || typeof variant.inventory_quantity === 'undefined') { return true; }
      return variant.inventory_quantity > 0;
    },

    // remove discount code
    discountRemove: function discountRemove() {
      var removeDiscountUrl = "/checkout?discount=%20";

      axios({
        url: removeDiscountUrl,
        method: "get"
      }).then(function(response) {
        $("#oa-cart__discount-input").val("");
        self.cartData.removedDiscount = self.cartData.discount;
        self.cartData.discount = null;
        self.cartData.discountPerc = null;
        self.cartData.discountValue = null;
        self.totalCal();
        console.log("discount removed");
        self.cartData.SuccessMessageCheck = true;
        self.cartData.SuccessMessage = "Your discount code is now removed!";

        self.genericEvent(
            "genericEvent",
            "Cart",
            "voucher delete",
            self.cartData.removedDiscount
        );
        reloadPageIE();
      });
    },

    // customer can readd discount code after removing it
    readdDiscount: function readdDiscount() {
      var self = this;
      var discountUrl = "/checkout?discount=" + this.cartData.removedDiscount;
      var discountCheckClick = $("#oa-cart__discount-submit");

      discountCheckClick.html(
          '<img src="https://cdn.shopify.com/s/files/1/1812/3759/files/loadinground.gif?18110229494894053591"/>'
      );

      //console.log(discountUrl);

      this.cartData.discount = this.cartData.removedDiscount;

      axios({
        url: discountUrl,
        method: "get"
      }).then(function(response) {
        discountCheckClick.html('<i class="fa fa-angle-right"></i>');
        self.cartData.currentDiscount = self.cartData.discount;
        self.cartData.discountData = response.data;
        var discountValue = $(response.data)
            .contents()
            .find("[data-checkout-discount-amount-target]")
            .attr("data-checkout-discount-amount-target");
        //console.log(discountValue);
        self.cartData.discountValue = parseInt(discountValue);
        self.cartData.removedDiscount = null;
        self.cartData.discountPerc = Math.round(
            (self.cartData.discountValue * 100) / self.cartData.subtotal
        );
        self.cartData.SuccessMessage = "Discount code is added to your cart.";
        self.cartData.SuccessMessageCheck = true;

        setTimeout(function() {
          self.cartData.SuccessMessageCheck = false;
        }, 20000);
        self.subtotalCal();

        self.genericEvent(
            "genericEvent",
            "Cart",
            "voucher undo",
            self.cartData.currentDiscount
        );
      });
    },

    ///////////////////////////// TRACKING FUNCTIONS ///////////////////////////

    getProductCategoryString: function getProductCategoryString(
        type,
        variant1,
        variant2
    ) {
      if(variant1 == undefined || variant2 == undefined){
        return;
      }
      if (variant1 == "Default Title") {
        variant1 = "none";
        variant2 = "Ebook";
      } else if (variant1.match(/\d/) !== null) {
        variant2 = variant1;
        variant1 = "none";
      }
      return type + variant1 + "/" + variant2;
    },
    getProductVariantString: function getProductVariantString(variant1) {
      if(variant1 == undefined){
        return;
      }
      if (variant1 == "Default Title") {
        variant1 = "Ebook";
      }

      if (variant1.trim().length == 0) {
        variant1 = undefined;
      }

      return variant1;
    },
    getProductBadges: function getProductBadges(onsale, tags, available) {
      var badges = [];
      if (onsale) badges.push("sale");
      if (tags.indexOf("best-seller") !== -1) badges.push("bestseller");
      if (tags.indexOf("flavor") !== -1) badges.push("new flavor");
      if (tags.indexOf("new") !== -1) badges.push("new product");
      if (!available) badges.push("sold out");

      return badges.join(", ");
    },
    getUniqueId: function getUniqueId(id, variantid) {
      var uniqueid = ["shopify", id, variantid];
      return uniqueid.join("_");
    },
    genericEvent: function genericEvent(event, category, action, label) {
      dataLayer.push({
        event: event,
        category: category,
        action: action,
        label: label
      });
      //console.log(event,category,action,label);
    },
    onChangeTracking: function onChangeTracking(item) {
      var onChangedItem = item.product_data.variants.filter(function(item) {
        return item.id == this;
      }, item.variant_id);
      var onChangedVariantTitle = onChangedItem[0].title;
      var freeProduct = "";

      if (onChangedItem[0].price == 0) {
        var freeProduct = "Free ";
      } else {
        var freeProduct = "";
      }

      dataLayer.push({
        event: "selectionMade",
        selectedElement: '"' + onChangedVariantTitle + '"',
        productTitle: freeProduct + item.product_title
      });
    },
    eeRemoveCart: function eeRemoveCart(item, index, action) {
      var trackingCurrency = "";
      var trackingCurrency = this.$store.getters['base/currencyCode'];

      var freeProduct = "";
      if (item.line_price == 0) {
        var freeProduct = "Free ";
      } else {
        var freeProduct = "";
      }

      dataLayer.push({
        event: action,
        ecommerce: {
          currencyCode: trackingCurrency,
          remove: {
            products: [
              {
                name: freeProduct + item.product_title,
                id: item.sku,
                price: this.moneyformatTracking(item.line_price),
                brand: item.vendor,
                category: this.getProductCategoryString(
                    item.product_type,
                    item.variant_options[0],
                    item.variant_options[1]
                ),
                variant: this.getProductVariantString(
                    item.variant_options[0]
                ),
                quantity: item.quantity,
                metric2: "-" + this.moneyformatTracking(item.line_price),
                dimension6: index,
                dimension17: this.getProductBadges(
                    item.original_line_price > item.price,
                    item.product_data.tags,
                    true
                )
              }
            ]
          }
        }
      });
      //console.log(dataLayer);
    },
    eeAddToCart: function eeAddToCart(item, index) {
      var trackingCurrency = "";
      var idCheck = false;
      var optionOne = item.variants[0].option1;
      var optionTwo = item.variants[0].option2;
      var varid = item.variants[0].id;
      var i = index;
      var trackingCurrency = this.$store.getters['base/currencyCode'];

      var freeProduct = "";
      if (item.line_price == 0) {
        var freeProduct = "Free ";
      } else {
        var freeProduct = "";
      }

      var self = this;
      item.variants.filter(function(item, event) {
        if (idCheck == false) {
          if (item.id == self.$store.state.cabs.cartCabSelected.id) {
            idCheck = true;
          } else {
            idCheck = false;
          }
        }
      });

      if (idCheck == true) {
        optionOne = this.$store.state.cabs.cartCabSelected.option1;
        optionTwo = this.$store.state.cabs.cartCabSelected.option2;
        varid = this.$store.state.cabs.cartCabSelected.id;
      } else {
      }

      dataLayer.push({
        event: "addToCart",
        ecommerce: {
          currencyCode: trackingCurrency,
          add: {
            actionField: { list: "Cart" },
            products: [
              {
                name: freeProduct + item.title,
                id: item.sku,
                price: item.price,
                brand: item.vendor,
                category: this.getProductCategoryString(
                    item.type,
                    optionOne,
                    optionTwo
                ),
                variant: this.getProductVariantString(optionOne),
                quantity: item.quantity,
                dimension6: i,
                metric2: this.moneyformatTracking(item.price),
                dimension99: this.getUniqueId(item.id, varid),
                dimension17: this.getProductBadges(
                    item.variants[0].compare_at_price > item.price,
                    item.tags,
                    true
                ),
                position: ""
              }
            ]
          }
        }
      });
    },
    ///////////////////////////// TRACKING FUNCTIONS ende ///////////////////////////

    // put Rewards products from collection (json) into vue variable
    rewardproducts: function rewardproducts() {
      var self = this;
      axios({
        url: "/cart?view=rewards",
        method: "get"
      }).then(function(response) {

        var cartRewards = response.data;
        // remove all product variants which are not defined in the skus array
        if(cartRewards == undefined || cartRewards.rewards == undefined) {return;}
        if (cartRewards.skus) {
          cartRewards.rewards = cartRewards.rewards.filter(function (product) {
            return Boolean(product);
          }).map(function (product) {
            product.variants = product.variants.filter(function (variant) {
              return cartRewards.skus.indexOf(variant.sku) !== -1;
            });
            return product;
          }).filter(function (product) {
            return product.variants.length > 0;
          });
        }


        // remove all unavailable variants
        cartRewards.rewards = cartRewards.rewards.filter(function (product) {
          return Boolean(product);
        }).map(function (product) {
          product.variants = product.variants.filter(function (variant) {
            return variant.available && (typeof variant.inventory_quantity === 'undefined' || variant.inventory_quantity > 3);
          });
          return product;
        }).filter(function (product) {
          return product.variants.length > 0;
        });

        //console.log(cartRewards.rewards);
        self.cartData.cartRewards = cartRewards;


        self.cartData.cartRewards.rewards.forEach(function(item,index){

          var itemIdToAdd = null;
          var variantFound = false;
          item.variants.forEach(function(variant, indexv) {
            if(variant.available && (typeof variant.inventory_quantity === 'undefined' || variant.inventory_quantity > 0) && variantFound == false){
              itemIdToAdd = variant.id;
              variantFound = true;
            }
          });

          self.cartData.cartRewardsSelected.items[index] = itemIdToAdd;

        });

        self.rewardChangedSelect();
        //console.log(response.data);
      });
    },
    fashionpromoproducts: function fashionpromoproducts() {
      if (this.settingFashionpromo !== '1') {
        return;
      }
      var self = this;

      if (self.fashionPromo.promoProducts.leggings.length > 0 && self.fashionPromo.promoProducts.tops.length > 0) {
        return;
      }

      axios.get("/cart?view=fashionpromo", { headers: { 'Cache-Control': 'no-cache, no-store','Pragma': 'no-cache', 'Expires': 0 } }).then(function(response) {

        self.fashionPromo.promoProducts = response.data;

        if (self.fashionPromo.leggingSelected.selected === -1 && self.fashionPromo.leggingSelected.selectedSize === -1) {
          var leggings = self.fashionPromoProducts.filter(function (product) {
            return self.validateFashionPromoProductLegging(product);
          });
          var legging;
          if (leggings.length > 0) {
            legging = leggings[0];
          }

          if (legging) {
            self.fashionPromo.promoProducts.leggings.forEach(function (product, index) {
              if (legging.product_data.id === product.id) {
                self.fashionPromo.leggingSelected.selected = index;
                product.variants.forEach(function (variant, index) {
                  if (legging.id === variant.id) {
                    self.fashionPromo.leggingSelected.selectedSize = index;
                  }
                });
              }
            });
          } else {
            self.fashionPromo.leggingSelected.selected = 0;
            self.fashionPromo.leggingSelected.selectedSize = -1;
          }

        }

        if (self.fashionPromo.topSelected.selected === -1 && self.fashionPromo.topSelected.selectedSize === -1) {
          var tops = self.fashionPromoProducts.filter(function (product) {
            return self.validateFashionPromoProductTop(product);
          });
          var top;
          if (tops.length > 0) {
            top = tops[0];
          }

          if (top) {
            self.fashionPromo.promoProducts.tops.forEach(function (product, index) {
              if (top.product_data.id === product.id) {
                self.fashionPromo.topSelected.selected = index;
                product.variants.forEach(function (variant, index) {
                  if (top.id === variant.id) {
                    self.fashionPromo.topSelected.selectedSize = index;
                  }
                });
              }
            });
          } else {
            self.fashionPromo.topSelected.selected = 0;
            self.fashionPromo.topSelected.selectedSize = -1;
          }
        }

        self.rewardChangedSelect();

      });
    },

    // validateRewardProduct: function validateRewardProduct(item){
    //   if(item.properties != null && item.properties.reward && item.properties.reward === true){
    //     var rewardItem = item;
    //     var rewardIndex = 0;
    //     if(this.cartData.cartRewards.rewards){
    //       this.cartData.cartRewards.rewards.forEach(function(item,index){
    //         if(rewardItem.product_id == item.id){
    //           rewardIndex = index;
    //         }
    //       });
    //       if(this.cartData.cartRewardsSelected.forceRemove !== true){
    //         if(this.cartData.cartRewardsSelected.radioIndex == null){
    //           this.cartData.cartRewardsSelected.radioIndex = rewardIndex;
    //           this.cartData.cartRewardsSelected.prevItem = rewardItem.id;
    //           //console.log(rewardItem.variant_options[0], rewardItem.id);
    //         }
    //       }
    //     }
    //     return true;
    //   } else {
    //     return false;
    //   }
    // },

    validateFashionPromoProduct: function validateFashionPromoProduct(item){
      if (this.settingFashionpromo !== '1') {
        return false;
      }
      return this.validateFashionPromoProductLegging(item) || this.validateFashionPromoProductTop(item);
    },

    validateFashionPromoProductLegging: function validateFashionPromoProduct(item){
      return item.properties != null && item.properties._fsolegging && item.properties._fsolegging === true;
    },

    validateFashionPromoProductTop: function validateFashionPromoProduct(item){
      return item.properties != null && item.properties.fsobra && item.properties.fsobra === true;
    },
    validateRechargeProduct: function validateRechargeProduct(item){
      return item.properties != null && item.properties.shipping_interval_frequency && item.properties.shipping_interval_frequency !== undefined;
    },
    updateFashionPromo: function updateFashionPromo (variant, property, validator, noLoadCart) {
      if (!variant || !validator) {
        return Promise.resolve();
      }

      var self = this;

      function add () {
        var addedVariants = self.fashionPromoProducts.filter(function (item) { return validator(item) && variant.id === item.id });
        if (addedVariants.length === 0) {
          var properties = {};
          properties[property] = true;

          return axios
              .post("/cart/add.js", {
                quantity: 1,
                id: variant.id,
                properties: properties,
              }).then(function (response) {
                if (noLoadCart !== true) {
                  self.loadCart()
                }
                return
              });
        } else {
          return Promise.resolve();
        }
      }

      var toDeleteRewardProducts = "";
      var axiosUpdateString = "";

      var axiosUpdateData = {};

      if (this.fashionPromoProducts.length > 0) {
        this.fashionPromoProducts.filter(function (item) { return validator(item) && variant.id !== item.id }).forEach(function(item,index){
          axiosUpdateData[item.id] = 0;
        });
      }

      if (Object.keys(axiosUpdateData).length > 0) {
        return axios
            .post("/cart/update.json", {
              updates: axiosUpdateData
            })
            .then(function (response) {
              return add();
            });
      } else {
        return add();
      }

    },
    fashionPromoReset: function fashionPromoReset() {
      var items = this.cartItems.filter(function (item) {
        return item.properties && (item.properties._fsolegging || item.properties.fsobra);
      });

      this.fashionPromo.leggingSelected.selectedSize = -1;
      this.fashionPromo.topSelected.selectedSize = -1;
      if (items.length < 1) {return;}

      var data = {};
      items.forEach(function (item) {
        data[item.variant_id] = 0;
      });

      var self = this;

      return axios
          .post("/cart/update.json", {
            updates: data
          }).then(function () {
            self.loadCart();
            self.fashionPromo.leggingSelected.selectedSize = -1;
            self.fashionPromo.topSelected.selectedSize = -1;
          });
    },

    // refresh bootstrap-select selectpicker
    rewardChangedSelect: function rewardChangedSelect() {
      setTimeout(function(){
        if (
            /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent)
        ) {
          $('div[select-index] .selectpicker').selectpicker("mobile");
        }
        $('div[select-index] .selectpicker').selectpicker();

        //console.log('select refresh');
      },1500);
    },
    refreshSelect: function refreshSelect() {
      setTimeout(function(){
        $('div[select-index] .selectpicker').selectpicker('refresh');
      },500);
    },
    rewardSelectChange: function rewardSelectChange(value, index){
      //console.log(value);
      //console.log('radio index: ',index);
      this.cartData.cartRewardsSelected.selected = value;
      this.cartData.cartRewardsSelected.radioIndex = index;
    },
    // reset reward
    rewardReset: function rewardReset() {
      this.cartData.cartRewardsSelected.forceRemove = true;

      var toDeleteRewardProducts = [];
      var axiosUpdateString;

      var self = this;

      if(this.rewardProducts.length>0){
        this.rewardProducts.forEach(function(item,index){
          if (self.rewardProducts.length == index + 1) {
            toDeleteRewardProducts += '"' + item.id + '": 0';
          } else {
            toDeleteRewardProducts += '"' + item.id + '": 0, ';
          }
        });

        //console.log(toDeleteRewardProducts);
        var jsonString = '{"updates": {' + toDeleteRewardProducts + "}}";
        //console.log(jsonString);

        axiosUpdateString = JSON.parse(jsonString);

        axios({
          url: "/cart/update.json",
          method: "post",
          data: axiosUpdateString
        })
            .then(function(response) {
              console.log('free gift reset');

              self.loadCart();
              self.cartData.cartRewardsSelected.selected = null;
              self.cartData.cartRewardsSelected.radioIndex = null;
              self.cartData.cartRewardsSelected.prevItem = null;

            }).catch(function(error){
          console.log(error);
        });
      }
    },
    validateNoteTracking: function validateNoteTracking() {
      var cSpecialOffer = Cookies.get('SONoteTracking', {domain: '.oneractive.com'});
      if(cSpecialOffer !== undefined){
        this.noteTracking = cSpecialOffer;
      }
    },
    algoliaCartSubmitTracking: function algoliaCartSubmitTracking(){
      var variantIds = [];
      this.cartItems.forEach(function(item){
        variantIds.push(JSON.stringify(item.id))
      });
      var algoliaEventData = {
        userToken: window.getUserUuid(),
        index: window.algoliaIndex,
        eventName: 'CART: Product passed to checkout',
        objectIDs: variantIds
      };
      aa('convertedObjectIDs', algoliaEventData);
    },

  },
  watch: {
    "cartType": function (newVal, oldVal){
      //console.log('carttype change', newVal)
      var self = this;
      axios.post('/cart/update.js', "attributes[carttype]="+newVal)
        .catch(function(error) {
          self.setCartError(error);
        });
    },
    "cartError": function cartDataTotal_price(newVal, oldVal) {
      if (this._cartErrorTimeout) {
        clearTimeout(this._cartErrorTimeout);
        this._cartErrorTimeout = null;
      }
      if (newVal === null) return;
      var self = this;
      this._cartErrorTimeout = setTimeout(function() {
        self.cartError = null;
        self._cartErrorTimeout = null;
      }, this.cartErrorDuration);
    },
    "cartData.cartCount":  function (newVal, oldVal) {
      if (oldVal < 1) {
        // update smile bp when cart was empty initially
        this.$nextTick(() => this.smileBPCalc());

        this.$nextTick(() => this.showHideFixedCheckout());
      }
    },
    "cartData.subtotal": function cartDataTotal_price(newVal, oldVal) {
      //console.log('total changes to'+ newVal, oldVal);
      //reset if value is lower
      if(this.settingFashionpromo !== '1'){
        return;
      }
      if(newVal < parseInt(this.settingFashionpromoValue) || this.fashionProducts.length == 0) {
        this.fashionPromoReset()
      }
      if (true) {
        var self = this;
        //console.log(newVal);
        self.updateFashionPromo(self.fashionPromoSelectedLeggingSize, '_fsolegging', self.validateFashionPromoProductLegging, true).then(function () {
          return self.updateFashionPromo(self.fashionPromoSelectedTopSize, 'fsobra', self.validateFashionPromoProductTop);
        });
      }
    },
    "cartData.cartRewardsSelected.radioIndex": function rewardsSelectedChange(newVal, oldVal) {
      //console.log('selected change ', oldVal,newVal,this.standartProducts);
      if(this.cartData.cartRewardsSelected.forceRemove !== true){
        this.cartData.cartRewardsSelected.selected = this.cartData.cartRewardsSelected.items[newVal];
      }
    },
    "cartData.cartRewardsSelected.items": function rewardsItemsChange(newVal, oldVal) {
      //console.log('reward change ',oldVal,newVal,this.standartProducts);
      if(this.cartData.cartRewardsSelected.forceRemove !== true){
        this.cartData.cartRewardsSelected.selected = newVal[this.cartData.cartRewardsSelected.radioIndex];
      }
    },
    "cartData.cartRewardsSelected.selected": function rewardsSelectedAdd(newVal, oldVal) {
      var self = this;
      // todo: add reward items as computed variable - find the item which needs to be removed and remove it
      if(this.cartData.cartRewardsSelected.forceRemove !== true ){

        var toDeleteRewardProducts = [];

        var axiosUpdateString;
        if(this.cartData.cartRewardsSelected.disableReward == false){
          this.cartData.cartRewardsSelected.disableReward = true;
          if(this.rewardProducts.length>0){
            //console.log('remove',oldVal);
            //console.log('add',newVal);

            // this.cartData.cartRewardsSelected.selected = this.rewardProducts[0].id;
            this.rewardProducts.forEach(function(item,index){
              if(self.cartData.cartRewardsSelected.prevItem != null){
                self.cartData.cartRewardsSelected.selected = self.cartData.cartRewardsSelected.prevItem;
              }

              if (self.rewardProducts.length == index + 1) {
                toDeleteRewardProducts += '"' + item.id + '": 0';
              } else {
                toDeleteRewardProducts += '"' + item.id + '": 0, ';
              }
            });
            //console.log(toDeleteRewardProducts);
            var jsonString = '{"updates": {' + toDeleteRewardProducts + "}}";
            //console.log(jsonString);

            axiosUpdateString = JSON.parse(jsonString);

            axios({
              url: "/cart/update.json",
              method: "post",
              data: axiosUpdateString
            })
                .then(function(response) {

                  //console.log('reward items deleted' , self.cartData.cartRewardsSelected.selected , 'added');

                  if(self.cartData.cartRewardsSelected.selected !== null){

                    var postUrl = "/cart/add.json";
                    var postQTY = 1;
                    self.standartProducts.filter(function(item){
                      //console.log(item)
                      if(item.id == self.cartData.cartRewardsSelected.selected){
                        return postQTY = 0;
                      }
                    });

                    var axiosData = {
                      'id': self.cartData.cartRewardsSelected.selected,
                      'quantity': postQTY,
                      'properties': {
                        'reward': true
                      }
                    };

                    axios
                        .post(postUrl, axiosData).then(function(response) {
                      self.cartData.cartRewardsSelected.prevItem = null;
                      self.loadCart().finally(function(){
                      });
                      //console.log('reward item added');

                      setTimeout(function(){
                        self.cartData.cartRewardsSelected.disableReward = false;
                      },500);

                    }).catch(function(error){
                      console.log(error);
                      setTimeout(function(){
                        self.cartData.cartRewardsSelected.disableReward = false;
                      },500);
                    });

                    $('div[select-index="'+self.cartData.cartRewardsSelected.radioIndex+'"] .selectpicker').val(self.cartData.cartRewardsSelected.selected);
                    $('div[select-index="'+self.cartData.cartRewardsSelected.radioIndex+'"] .selectpicker').selectpicker('refresh');

                  }else {
                  }
                  //console.log('delete free products');
                })
                .catch(function(error) {
                  return console.log(error);
                });

          }else{

            if(this.cartData.cartRewardsSelected.selected !== null){
              axios
                  .post("/cart/add.js", {
                    quantity: 1,
                    id: this.cartData.cartRewardsSelected.selected,
                    properties: {
                      'reward': true
                    }
                  }).then(function(response) {
                self.cartData.cartRewardsSelected.prevItem = null;
                self.loadCart();
                //console.log('item added');
                console.log('post ajax 2 ', oldVal,newVal,self.standartProducts, self.rewardProducts);
                setTimeout(function(){
                  self.cartData.cartRewardsSelected.disableReward = false;
                },500);
              }).catch(function(error){
                console.log(error);
                setTimeout(function(){
                  self.cartData.cartRewardsSelected.disableReward = false;
                },500);
              });
            }else {
            }
            // console.log('testtest');
          }
        }
      }
      console.log('post ajax 3', oldVal,newVal,self.standartProducts, self.rewardProducts);
    },
    isBusy: function isBusy(newVal, oldVal) {
      if (oldVal == true && newVal == false) {
        this.cartChangedSelect();
        //this.checkPriceFreeProducts();
      }
      //remove height flicker from pricing section
      if (this.isBusy == true) {
        var elementHeight = $(".cart_background").height();
        $(".cart_background").css("height", elementHeight);
        //console.log('busy changes'+ elementHeight);
      } else {
        $(".cart_background").css("height", "auto");
      }

    },
    fashionPromoSelectedLegging:  function fashionPromoSelectedLegging() {
      this.refreshSelect();
    },
    fashionPromoSelectedTop: function fashionPromoSelectedTop() {
      this.refreshSelect();
    },
    fashionPromoSelectedLeggingSize: function fashionPromoSelectedLeggingSize() {
      this.updateFashionPromo(this.fashionPromoSelectedLeggingSize, '_fsolegging', this.validateFashionPromoProductLegging);
    },
    fashionPromoSelectedTopSize: function fashionPromoSelectedTopSize(oldVariant, newVariant) {
      var self = this;
      setTimeout(function() {
        self.updateFashionPromo(self.fashionPromoSelectedTopSize, 'fsobra', self.validateFashionPromoProductTop);
      }, oldVariant && !newVariant ? 1000 : 0);
    }
  },

  computed: {
    ...Vuex.mapGetters("base", ["moneyformat", "moneyPercFormat"]),
    currency: function() {
      return this.$store.getters['base/currencyCode'];
    },
    // checks if isBusy true or false and sets the opacity for a smooth loading
    cartStyle: function cartStyle() {
      return this.isBusy
          ? "opacity: 0.35;transition: all 0.15s;cursor:progress"
          : "opacity: 1;transition: all 0.15s;";
    },
    // checks if isBusy true or false and sets the opacity to 0 or 1 for a smooth loading
    cartPriceStyle: function cartPriceStyle() {
      return this.isBusy
          ? "opacity: 0.0;transition: all 0.05s;"
          : "opacity: 1;transition: all 0.15s;";
    },

    // firter cartItems array for free items
    freeProducts: function freeProducts() {
      var self = this;
      return this.cartItems.filter(function(item) {
        if(!self.validateRewardProduct(item) && !self.validateFashionPromoProduct(item)){
          return item.line_price === 0;
        }
      });
    },

    // firter cartItems array for priced items
    standartProducts: function standartProducts() {
      var self = this;
      return this.cartItems.filter(function(item) {
        if(!self.validateRewardProduct(item) && !self.validateFashionPromoProduct(item)){
          return item.line_price !== 0;
        }
      });
    },
    cartCount: function cartCount() {
      var self = this;
      var cartCount = 0;
      this.cartItems.forEach(function(item) {
        cartCount += item.quantity;
      });
      return cartCount;
    },

    freesportsbra: function freesportsbra() {
      var self = this;
      var hasbra = false;
      this.freeProducts.forEach(function(item) {
        if(item.handle=="gift-sportswear-3"){
          hasbra = true;
        }
      });
      return hasbra;
    },
    // firter cartItems array for priced items
    reChargeProducts: function reChargeProducts() {
      var self = this;
      return this.cartItems.filter(function(item) {
        if(self.validateRechargeProduct(item) && !self.validateRewardProduct(item) && !self.validateFashionPromoProduct(item)){
          window.sharedRechargeProducts = item;
          return item;
        }
      });
    },
    // filter cartItems array for flatrate item
    bogoProducts: function bogoProducts() {
      return this.cartItems.filter(function(item) {
        return typeof item.product_data !== 'undefined' && item.product_data.tags.indexOf('bogo') != -1;
      });
    },
    // firter cartItems array for flatrate item
    underwearOfferProducts: function underwearOfferProducts() {
      return this.cartItems.filter(function(item) {
        return typeof item.product_data !== 'undefined' && item.product_data.tags.indexOf('buy-3-save-15') != -1;
      });
    },
    // firter cartItems array for flatrate item
    flatrateProducts: function flatrateProducts() {
      var self = this;
      return this.cartItems.filter(function(item) {
        if(!self.validateRewardProduct(item) && !self.validateFashionPromoProduct(item)){
          return item.line_price !== 0 && item.product_data.tags.indexOf('flatrate') != -1;
        }
      });
    },
    offerSubtotal: function offerSubtotal() {
      var offersub = 0
      this.cartItems.filter(function(item) {
        if(true){
          offersub = offersub + item.original_line_price;
        }
      });
      return offersub;
    },
    newReleasesProducts: function newReleasesProducts() {
      return this.cartItems.filter(function(item) {
        if(item.product_data.tags.indexOf('new') != -1){
          return item;
        }
      });
    },
    defineProducts: function defineProducts() {
      return this.cartItems.filter(function(item) {
        if(item.product_data.tags.indexOf('define') != -1){
          return item;
        }
      });
    },
    fashionProducts: function fashionProducts() {
      return this.cartItems.filter(function(item) {
        if(item.product_data.tags.indexOf('product_line_fashion') != -1 && item.properties._fsolegging != true){
          return item;
        }
      });
    },
    // firter cartItems array for priced items
    rewardProducts: function rewardProducts() {
      var self = this;
      return this.cartItems.filter(function(item) {
        if(self.validateRewardProduct(item)){
          if(item.properties.reward == true){
            return item;
          }
        }
      });
    },
    freeGifts: function() {
      return new CartFreeGifts(this.$store.state.base.currentShop, this.$store.state.base.currentLang);
    },
    gifts: function () {
      return this.freeGifts.gifts;
    },
    freeShippingFrom: function() {
      return this.freeGifts.freeShippingFrom;
    },
    freeExpressShippingFrom: function() {
      return this.freeGifts.freeExpressShippingFrom;
    },
    // firter cartItems array for priced items
    scriptPromoSavings: function scriptPromo() {
      var scriptPromoName = false;
      this.cartItems.filter(function(item) {
        if(item.line_level_discount_allocations[0] && item.line_level_discount_allocations[0].discount_application.title){
          var tmp = item.line_level_discount_allocations[0].discount_application.title.split('|')[1];
          if (tmp) {
            scriptPromoName = tmp.match(/\d+/)[0]*100;
          }
        }
      });
      return scriptPromoName;
    },
   
    // firter cartItems array for priced items
    fashionPromoProducts: function fashionPromoProducts() {
      var self = this;
      return self.cartItems.filter(function(item) {
        if(self.validateFashionPromoProduct(item)){
          return item;
        }
      });
    },
    fashionPromoSelectedLegging: function fashionPromoSelectedLegging() {
      return this.fashionPromo.promoProducts.leggings[this.fashionPromo.leggingSelected.selected]
    },
    fashionPromoSelectedTop: function fashionPromoSelectedTop() {
      return this.fashionPromo.promoProducts.tops[this.fashionPromo.topSelected.selected]
    },
    fashionPromoSelectedLeggingSize: function fashionPromoSelectedLeggingSize() {
      if (!this.fashionPromoSelectedLegging || typeof this.fashionPromoSelectedLegging.variants === 'undefined') {
        return null;
      }
      return this.fashionPromoSelectedLegging.variants[this.fashionPromo.leggingSelected.selectedSize]
    },
    fashionPromoSelectedTopSize: function fashionPromoSelectedTopSize() {
      if (!this.fashionPromoSelectedTop || typeof this.fashionPromoSelectedTop.variants === 'undefined') {
        return null;
      }
      return this.fashionPromoSelectedTop.variants[this.fashionPromo.topSelected.selectedSize]
    },
    shouldShowRewards: function shouldShowRewards() {
      return (typeof this.reChargeProducts === 'undefined' || this.reChargeProducts.length === 0) && (this.cartData.cartRewards.rewards && this.cartData.cartRewards.rewards.length > 0);
    }
  },
});

var el = document.getElementById('vue-app');

var vueapp = new VueCart({
  name: 'Cart',
  el: el,
  // props: ['settingSaleAjax', 'settingFashionpromo','settingFashionpromoValue', 'flatrateVariantids', 'flatrateProdids', 'flatratePrice', 'flatrateCompprice'],
  propsData: el.dataset,
  store: vuestore,
});



























































function reloadPageIE() {
  /* if (/msie|trident/i.test(navigator.userAgent)) {
    location.reload();
  } */
}



function CartShopUtils(currentShop, currentLang) {
  function currencySymbol() {
    switch(currentShop) {
      case 'de':
      case 'eu':
        return '€';
      case 'uk':
        return '£';
      case 'au':
        return '$';
      case 'ca':
        return '$';
      case 'us':
      case 'com':
      default:
        return '$';
    }
  }
  function currencyCode() {
    switch(currentShop) {
      case 'de':
      case 'eu':
        return 'EUR';
      case 'uk':
        return 'GBP';
      case 'au':
        return 'AUD';
      case 'ca':
        return 'CAD';
      case 'us':
      case 'com':
      default:
        return 'USD';
    }
  }
  function priceSeparatorUs() {
    switch(currentShop) {
      case 'de':
        return false;
      case 'eu':
        return true;
      case 'uk':
      case 'au':
      case 'ca':
      case 'us':
      case 'com':
      default:
        return true;
    }
  }
  function language() {
    return currentLang.toUpperCase();
  }
  function freeShippingFrom() {
    try {
      var ipShopCache = GeoRedirect.getIpShopCache();
      var countryCode = ipShopCache && ipShopCache.country_code;
    } catch (err) {
      console.log('Georedirect undefined',err);
      var countryCode = '';
    }
    switch(currentShop) {
      case 'de':
        switch (countryCode) {
          case 'CH':
            return 15000;
          case 'LI':
            return 9000;
        }
        return 5900;
      case 'eu':
        switch (countryCode) {
          case 'FR':
          case 'IE':
            return 5900;
        }
        return 9900;
      case 'uk':
        return 6000;
      case 'au':
        return 15000;
      case 'ca':
        return 12000;
      case 'us':
        return 9000;
      case 'com':
        switch (countryCode) {
          case 'CN':
            return 0;
        }
        return 30000;
      default:
        return 0;
    }
  }
  return {
    currencySymbol: currencySymbol(),
    language: language(),
    currencyCode: currencyCode(),
    priceSeparatorUs: priceSeparatorUs(),
    freeShippingFrom: freeShippingFrom(),
  };
}


















/*******************/
function CartFreeGifts(currentShop, currentLang) {

  function freeShippingFrom() {
    try {
      var ipShopCache = GeoRedirect.getIpShopCache();
      var countryCode = ipShopCache && ipShopCache.country_code;
    } catch (err) {
      console.log('Georedirect undefined', err);
      var countryCode = '';
    }
    switch (currentShop) {
      case 'de':
        switch (countryCode) {
          case 'CH':
            return 9000;
          case 'LI':
            return 9000;
        }
        return 5900;
      case 'eu':
        switch (countryCode) {
          case 'FR':
          case 'IE':
            return 5900;
        }
        return 9900;
      case 'uk':
        return 6000;
      case 'au':
        return 15000;
      case 'ca':
        return 12000;
      case 'us':
        return 9000;
      case 'com':
        return 0;
      default:
        return 0;
    }
  }

  function freeExpressShippingFrom() {
    try {
      var ipShopCache = GeoRedirect.getIpShopCache();
      var countryCode = ipShopCache && ipShopCache.country_code;
    } catch (err) {
      console.log('Georedirect undefined', err);
      var countryCode = '';
    }
    return 0; 
    switch (currentShop) {
      case 'de':
        switch (countryCode) {
          case 'CH':
            return;// 15000;
          case 'LI':
            return 0;
          case 'AT':
            return 0;//15000;
        }
        return 0;
      case 'eu':
        return 0;
      case 'uk':
        return 0;//15000;
      case 'au':
        return 0;//25000;
      case 'ca':
        return 0;//22000;
      case 'us':
        return 0;
      case 'com':
        switch (countryCode) {
          case 'CN':
            return 0;
        }
        return 0;//20000;
      default:
        return 0;
    }
  }

  var gifts = [];

  var freeShippingFromValue = freeShippingFrom();
  if (freeShippingFromValue > 0) {
    gifts.push({
      title: (function () {
        switch (currentLang) {
          case 'de': return 'Standardversand';
          default: return 'standard shipping';
        }
      })(),
      value: freeShippingFromValue,
    });
  }

  var freeExpressShippingFromValue = freeExpressShippingFrom();
  if (freeExpressShippingFromValue > 0) {
    gifts.push({
      title: (function () {
        switch (currentLang) {
          case 'de': return 'Expressversand';
          default: return 'express shipping';
        }
      })(),
      value: freeExpressShippingFromValue,
    });
  }

  /*
  gifts.push({
    title: (function () {
      switch (currentLang) {
        case 'de': return '10% extra-Rabatt';
        default: return 'extra 10% off';
      };
    })(),
    value: (function () {
      switch (currentShop) {
        case 'de': return 8000;
        case 'au': return 12000;
        case 'ca': return 12000;
        case 'eu': return 8000;
        case 'uk': return 6000;
        case 'us': return 9000;
        case 'com': return 9000;
        default: return 9000;
      };
    })(),
  });
  gifts.push({
    title: (function () {
      switch (currentLang) {
        case 'de': return '15% extra-Rabatt';
        default: return 'extra 15% off';
      };
    })(),
    value: (function () {
      switch (currentShop) {
        case 'de': return 6500;
        case 'au': return 14000;
        case 'ca': return 12000;
        case 'eu': return 6500;
        case 'uk': return 6000;
        case 'us': return 6500;
        case 'com': return 10000;
        default: return 15000;
      };
    })(),
  });
  gifts.push({
    title: (function () {
      switch (currentLang) {
        case 'de': return '20% extra-Rabatt';
        default: return 'extra 20% off';
      };
    })(),
    value: (function () {
      switch (currentShop) {
        case 'de': return 10000;
        case 'au': return 20000;
        case 'ca': return 20000;
        case 'eu': return 10000;
        case 'uk': return 8000;
        case 'us': return 10000;
        case 'com': return 14000;
        default: return 15000;
      };
    })(),
  });
*/

  vueapp.giftscale.settings.forEach(function(gift){
    if(vueapp.cartType == gift.category){
      gifts.push({
        title: gift.message,
        value: gift.over,
      });
    }
  });


  return {
    gifts: gifts.filter(function (item) {
      return item && item.title && item.value >= 0;
    }).sort(function (a, b) {
      return a.value > b.value ? 1 : -1;
    }),
    freeShippingFrom: freeShippingFromValue,
    freeExpressShippingFrom: freeExpressShippingFromValue,
  }
}